module.exports = __webpack_public_path__ + "img/dp-ld-sy1.2ca31a1a.png";